<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col cols="12">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Modifica Listino</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
                    <fields-generator
                        class="pt-3"
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>
                    <small class="px-4">* Indica i campi obbligatori</small>
                </v-container>
            </v-card>
        </v-col>

        <v-col class="pt-2" cols="12">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Destinazioni</p>
                    <v-spacer></v-spacer>
        			<v-row class="pa-0 pr-4">
                        <v-text-field class="hidden-xs-only"
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            dense
                            outlined
                        ></v-text-field>
        			</v-row>
                    <v-toolbar-items>
                        <v-btn icon text @click.stop="expand = !expand">
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>                      
                    </v-toolbar-items>
                </v-card-title>                
                <v-divider></v-divider>

                <v-container class="pa-0" fluid>
                    <v-slide-y-transition>
                        <v-card class="background-2 py-2" elevation="0" v-show="expand">
                            <v-row class="pl-4 mx-0">
                                <div class="body-2">Inserisci l'importo da incrementare a tutti i prezzi delle destinazioni selezionate</div>
                            </v-row>
                            <v-row class="pl-4">
                                <v-col lg="3" cols="12">
                                    <v-text-field
                                        label="Importo"
                                        type="number"
                                        clearable
                                        v-model="increment"
                                        dense
                                        outlined>
                                        <v-btn text icon color="success" slot="append-outer">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" @click="incrementPrice('import')" slot="activator">playlist_add</v-icon>
                                                </template>
                                                <span>Incrementa</span>
                                            </v-tooltip>
                                        </v-btn>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pl-4 mx-0">
                                <div class="body-2">Inserisci l'importo percentuale da incrementare a tutti i prezzzi delle destinazioni selezionate</div>
                            </v-row>
                            <v-row class="pl-4">
                                <v-col lg="3" cols="12">
                                    <v-text-field
                                        label="Importo %"
                                        type="number"
                                        suffix="%"
                                        clearable
                                        v-model="incrementPerc"
                                        dense
                                        outlined>
                                        <v-btn text icon color="success" slot="append-outer">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" @click="incrementPrice('percentage')" slot="activator">playlist_add</v-icon>
                                                </template>
                                                <span>Incrementa in %</span>
                                            </v-tooltip>
                                        </v-btn>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-card-actions row>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="toggleAll">{{ this.selected.length ? 'Deseleziona tutti' : 'Seleziona tutti' }}</v-btn>
                                <v-btn text color="red" :disabled="!this.selected.length" @click="confirmDelete = true">Elimina</v-btn>
                            </v-card-actions>
                            <v-divider></v-divider>
                        </v-card>
                    </v-slide-y-transition>
                    <v-progress-linear v-show="loading" height="2" class="my-0" :indeterminate="loading"></v-progress-linear>
                    <v-data-table v-if="computed"
                        :options.sync="pagination"
                        :items="telephone_destinations"
                        :headers="headers"
                        v-model="selected" 
                        :search="search"
                        class="background-2"
                        show-select>
                        <template v-slot:header.data-table-select="{ on, props }">
                            <v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
                        </template>

			            <template v-slot:item="props">
                            <tr style="height: 82px;">
                                <td>
                                    <v-simple-checkbox color="primary" :value="props.isSelected" @input="props.select($event)"></v-simple-checkbox>
                                </td>
                                <td class="px-2" style="width: 40px; font-size: 14px !important; font-weight: 500; text-align: center;">
                                    {{ props.index + 1 + pagination.itemsPerPage * ( pagination.page - 1 ) }}
                                </td>
                                <td style="width: 91px">
                                    <v-btn icon small class="mx-0" @click.stop="editPricelistProduct(props.item.id, props.index)">
                                        <v-icon color="teal">{{editIndex == props.index ? 'check' : 'edit'}}</v-icon>
                                    </v-btn>
                                    <v-btn icon small class="mx-0" @click.stop="deleteItem(props.item.id, props.index)">
                                        <v-icon color="pink">delete</v-icon>
                                    </v-btn>
                                </td>
                                <td style="max-width: 200px">
                                    <v-autocomplete v-if="editIndex == props.index" 
                                        :items="itemsLists"
                                        label="Destinazione"
                                        v-model="telephone_destinations[props.index + pagination.itemsPerPage * ( pagination.page - 1 )]['telephone_destination_id']"
                                        small-chips
                                        deletable-chips
                                        item-text="text"
                                        item-value="value"
                                        :error-messages="errors.collect('Destinazione'+props.index)"
                                        v-validate="'required'"
                                        :data-vv-name="'Destinazione'+props.index" 
                                        data-vv-as="Destinazione"
                                        dense>
                                        <template slot="item" slot-scope="{ item }">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ $trans(item.type) }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-icon>mdi-coin</v-icon>
                                            </v-list-item-action>
                                        </template>
                                    </v-autocomplete>
                                    <span v-else>
                                        {{ printProductName(props.index + pagination.itemsPerPage * ( pagination.page - 1 )) }}
                                    </span>
                                </td>
                                
                                <td style="max-width: 100px;">
                                    <v-text-field v-if="editIndex == props.index"
                                        type=number
                                        label='Prezzo'
                                        v-model.number="props.item['price']"
                                        :error-messages="errors.collect('Prezzo'+props.item.id)"
                                        v-validate="'required'"
                                        :data-vv-name="'Prezzo'+props.item.id" 
                                        data-vv-as="Prezzo"
                                        suffix="€"
                                    ></v-text-field>
                                    <span v-else>
                                        {{ props.item['price'] | currency }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                            Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                        </template>
                    </v-data-table>
                </v-container>
                <v-card-text style="position: relative">
                    <v-fab-transition>
                        <v-btn
                            @click.native="addPricelistProduct"
                            color="primary"
                            small
                            dark
                            absolute
                            bottom
                            left
                            fab>
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </v-card-text>
            </v-card>
        </v-col>
        <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
                <v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="updateModel()"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>sync</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Modifica</span>
        </v-tooltip>
        <confirm-dialog 
			:confirmModel.sync="confirmDelete"
			mainTitle="Eliminare gli elementi selezionati?"
			secondTitle="Gli elementi selezionati verranno eliminati, per salvare l'eliminazione ricordati di premere Aggiorna"
			:atConfirm="deleteSelected"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>
		<confirm-dialog
			:confirmModel="confirmExit"
			:mainTitle="$trans('save_primary_message')"
			:secondTitle="$trans('save_secondary_message')"
			@update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
			:atConfirm="updateModel"
			:atExit="exit"
		></confirm-dialog>
    </v-row>
</template>

<script>
    import Vue from 'vue'
    import FormsMixin from '@/mixins/FormsMixin'

    export default {
        name: 'telephone-pricelist-edit',
        mixins: [FormsMixin],
        props: {
            id: Number,
            modelDef: String,
            redirect: Object,
        },

        data() {
            return {
                url: '',
                model: {},
                items: {},
                next: null,
                search: '',
                increment: 0,
                selected: [],
                saved: false,
                fieldsset: {},
                expand: false,
                pagination: {},
                changed: false,
                loading: false,
                editIndex: null,
                computed: false,
                incrementPerc: 0,
                csvPricelist: null,
                confirmExit: false,
                confirmDelete: false,
                fieldsset_telephonepricelistdestination: {},
            }
        },

        // beforeRouteLeave(to, from, next) {
        //     if(this.$store.getters.modelEdited) {
        //         this.confirmExit = true
        //         this.next = next
        //     } else {
        //         next()
        //     }
        // },

        watch: {
            modelForWatcher: {
                handler(newVal, oldVal) {
                    if(!_.isEmpty(oldVal) && !this.$store.getters.progress && (JSON.stringify(newVal) !== JSON.stringify(this.oldVal))) {
                        this.$store.commit('setModelEdited', true)
                    }
                },
                deep: true,
            },

            editIndex: {
                handler(newVal, oldVal) {
                    if(oldVal != null) {
                        let data = this.model.telephone_destinations[oldVal]
                        delete data.destination
                        this.axios.post('telephone_pricelist_destination', data).then(response => {
                            // get body data
                            this.saved = false
                            this.$store.commit('setSnackbar', {timeout: 6000, text: 'Salvato', value: true, color: 'success'})
                            this.model.telephone_destinations[oldVal].id = response.data.id

                        }, response => {
                            // error callback
                        })
                    }
                },
            },
        },

        created() {
            this.getEdit()
        },

        beforeDestroy() {
            this.$store.commit('setModelEdited', false)
        },
        
        computed: {
            
            itemsLists() {
                let selected = this.model.telephone_destinations.map((sel) =>  sel.destination)
                return this.fieldsset_telephonepricelistdestination.telephone_destinations.map((tel_dest) => {
                    return selected.includes(tel_dest.text) ? {...tel_dest, disabled: true } : tel_dest
                })
            },

            modelForWatcher() {
                return _.cloneDeep(this.model);
            },

            printProductName() {
                return (index) => {
                    if(this.telephone_destinationsById[this.telephone_destinations[index]['telephone_destination_id']] && this.telephone_destinationsById[this.telephone_destinations[index]['telephone_destination_id']]['text']) {
                        return this.telephone_destinationsById[this.telephone_destinations[index]['telephone_destination_id']]['text']
                    } else ''
                }
            },

            selectedId() {
                return this.selected.map((item) => {
                    return item.id
                }) 
            },

            telephone_destinations() {
                return this.model.telephone_destinations
            },

            telephone_destinationsById() {
                return this.fieldsset_telephonepricelistdestination.telephone_destinations.reduce((obj, product) => {
                    obj[product.value] = product
                    return obj 
                }, {})
            },

            totalItems() {
                return this.telephone_destinations.length
            },

            headers() {
                let headers = [
                    {
                        'text': 'Numero',
                        'value': 'number',
                        sortable: false
                    }, 
                    {
                        'text': 'Azioni',
                        'value': 'action',
                        sortable: false
                    }, 
                    {
                        'text': 'Destinazione',
                        'value': 'destination',
                        sortable: false
                    }, 
                    {
                        'text': 'Prezzo',
                        'value': 'price',
                        sortable: false
                    },
                ]
                return headers
            }
        },


        methods: {

            getEdit() {
                this.axios.get(this.modelDef + '/' +this.id + '/edit').then(response => {
                    this.fieldsset = response.data.fields
                    this.fieldsset_telephonepricelistdestination = response.data.telephone_pricelist_destination_fields.fields

                    this.model = response.data.model
                    this.computed = true
                    this.$store.commit('endProgress')
                
                }, response => {
                    // error callback
                })
            },

            exit() {
                this.$store.commit('setModelEdited', false)
                this.next()
            },

            toggleAll() {
                if (this.selected.length) {
                    this.selected = []   
                } else { 
                    this.selected = this.telephone_destinations.slice()
                }        
            },

            editPricelistProduct(id, index) {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    if(this.editIndex == index) {
                        this.editIndex = null
                    } else {

                        this.editIndex = index
                    }
                }).catch(() => {
                    
                })
            },

            incrementPrice(type) {
                this.axios.post('telephone_pricelists-increments/' + this.model.id, {'type': type, 'import': type == 'import' ? parseFloat(this.increment) : parseFloat(this.incrementPerc) }).then(response => {
                    // get body data
                    this.saved = false
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Listino aggiornato.', value: true, color: 'success'})
                    this.getEdit()
                }, response => {
                    // error callback
                })
            },

            deleteItem(id, index) {
                this.axios.post('telephone_pricelist_destination/delete', {'ids': [id]}).then(response => {
                    // get body data
                    this.saved = false
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Eliminato', value: true, color: 'success'})
                    this.telephone_destinations.splice(index, 1)
                }, response => {
                    // error callback
                })
            },

            deleteSelected() {
                this.model.telephone_destinations = this.telephone_destinations.filter((item) => {
                    return !this.selectedId.includes(item.id)
                })
                this.confirmDelete = false
            },

            addPricelistProduct() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    if(this.editIndex != null) {
                        this.axios.post('telephone_pricelist_destination', this.model.telephone_destinations[this.editIndex]).then(response => {
                            // get body data
                            this.saved = false
                            this.$store.commit('setSnackbar', {timeout: 6000, text: 'Salvato', value: true, color: 'success'})
                            this.model.telephone_destinations[this.editIndex].id = response.data.id
                        }, response => {
                            // error callback
                        })
                    }
                    let defaultObject = {'telephone_pricelist_id': this.model.id, 'id': 0, 'price': 0}
                    this.model.telephone_destinations.unshift(defaultObject) 
                    this.editIndex = 0
                    Vue.set(this.pagination,'page', 1)
                }).catch(() => {
                    
                })
            },

            updateModel() {
                this.confirmExit = false
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            return false
                        }

                        this.saved = true
                        let data = this.model
                        delete data.telephone_destinations

                        this.axios.put(this.modelDef + '/' + this.id, data).then(response => {
                            // get body data
                            this.model = {}
                            this.saved = false
                            this.$store.commit('setModelEdited', false)

                            if(this.next != null) {
                                this.next()
                            } else {
                                this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDef)
                            }
                        }, response => {
                            // error callback
                        })
                    }).catch(() => {

                    })
                }).catch(() => {
                    
                })
            },
        },
    }
</script>
